import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LocalTimePipe } from './pipes/local-time.pipe';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';
import { SupportComponent } from './components/support/support.component';

@NgModule({
  imports: [CommonModule, SharedModule, I2gNgTrackingModule],
  declarations: [SupportComponent, LocalTimePipe],
  exports: [SupportComponent],
})
export class SupportModule {}
